// extracted by mini-css-extract-plugin
export default {"submit":"Submit_submit__VcCXh"};